// extracted by mini-css-extract-plugin
export default {"icon":"FriendCard_icon__v0Pka","name":"FriendCard_name__R5mqM","friendCard":"FriendCard_friendCard__lSlRQ"};